module.exports = __webpack_public_path__ + "img/logoSmart.41c23b6c.png";